module.exports = __webpack_public_path__ + "img/IMG_3289.3292e16d.jpg";